import React from 'react';
import StripeSuccess from 'assets/payment/StripeSuccess.png';
import s from './s.module.less';
import { PATH } from 'constants/path';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';

const PaymentSetupSuccess = () => {
    const navigate = useNavigate();

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <img
                    onClick={() => {
                        navigate(PATH.DASHBOARD);
                    }}
                    src="https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/ui/logo_kiwihealth_by_klarity_380x96.png"
                    className={s.logo}
                    alt="Kiwi Health Logo"
                />
            </div>
            <div className={s.content}>
                <img src={StripeSuccess} className={s.successImg} alt="Payment Setup Success Icon" />
                <div className={s.title}>🎉 Setup submitted!</div>
                <div className={s.description}>
                    Thanks for completing your practice and payment setup. Stripe is now verifying your payment details. We’ll notify you once everything is confirmed.
                </div>
                <div className={s.description}>
                    In the meantime, let’s explore how Kiwi can help you grow your practice by increasing your online visibility.
                </div>
                <Button
                    type="primary"
                    onClick={() => {
                        navigate(PATH.DASHBOARD);
                    }}
                    size="large"
                    style={{ width: '353px' }}
                >Back to homepage
                </Button>
            </div>
        </div>
    );
};

export default PaymentSetupSuccess;
